const UI_KEY = 'budgetapp_ui';
const defaults = {
    year: new Date().getFullYear(),
    month: new Date().getMonth(),
    selectedDate: null,
    calMode: 'month',
    view: 'home',
    budgetView: 'calendar',
    currentId: null,
};
export function loadUIState() {
    try {
        const raw = localStorage.getItem(UI_KEY);
        if (!raw)
            return { ...defaults };
        return { ...defaults, ...JSON.parse(raw) };
    }
    catch {
        return { ...defaults };
    }
}
export function saveUIState(prefs) {
    localStorage.setItem(UI_KEY, JSON.stringify(prefs));
}
